define('SageDotCom/DataLayer/Global/ccaas-chat-tracker',[
    "jquery",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/DataLayer/Events/Ccaas/ccaasEvent",
    "SageDotCom/DataLayer/Events/Ccaas/ccaasTracking",
    "SageDotCom/DataLayer/Events/buttonClick",
    "SageDotCom/DataLayer/Events/Ccaas/ccaasAltEvent",
    "eventManager"
],
    function ($, tealium, CcaaSEvent, CcaasTracking, buttonClickEvent, CcaasAltEvent, eventManager) {
        const defaultTimeoutValue = 3000;
        const observerTimeoutValue = 60000;
        const ccaasBubbleSelector = ".ccaas-btn, .cs-button, .open-live-chat";
        const startChatButtonSelector = '[aria-label="Start Chat"], [aria-label="Lancer un chat"]';
        const messageInputSelector = ".cx-input-container";
        const ccaasFirstName = "#cx_webchat_form_firstname";
        const ccaasNameInput = "#cx_webchat_form_name";
        const ccaasAccount = "#cx_webchat_form_accountnumber";
        const ccaasSubject = "#cx_webchat_form_subject";
        const ccaasEmail = "#cx_webchat_form_email";
        const ccaasCancel = "div.cx-button-group.cx-buttons-binary button[data-message='ChatFormCancel']";
        const ccaasMinimize = "div.cx-button-group.cx-buttons-window-control button[data-icon='minimize']";
        const ccaasClose = "div.cx-button-group.cx-buttons-window-control button[class='cx-icon cx-button-close']";

        //CCAAS ALT SELECTORS
        const ccaasAltBubbleSelector = ".cx-sidebar-button";
        const ccaasAltCloseIconSelector = ".cx-button-close";
        const ccaasAltMinimizeIconSelector = ".cx-button-minimize";
        const ccaasAltModalFormSendChatSelector = ".cx-webchat";
        const ccaasAltModalFormSendMessageSelector = ".cx-send-message";
        const ccaasAltModalFormEmailSelector = "#cx_sendmessage_form_email";
        const ccaasAltModalFormFirstnameSelector = "#cx_sendmessage_form_firstname";
        const ccaasAltModalFormQuestionSelector = "#cx_sendmessage_form_votre_question";
        const ccaasAltModalFormSendButtonSelector = "button[data-message='Send']";
        const ccaasAltModalFormSendSuccess = ccaasAltModalFormSendMessageSelector;
        const ccaasAltModalFormSendSuccessTextSelector = "*[data-message='Sent']";
        const ccaasAltModalCallBackSelector = ".cx-callback";
        const ccaasAltModalCallBackConfirmButtonSelector = "button[data-message='ConfirmButtonText']";
        const ccaasAltModalCallBackCancelButtonSelector = "button[data-message='CancelButtonText']";
        const ccaasAltModalCallBackDesiredTimeSelector = 'button[class^="cx-callback-time-item"]';
        const ccaasAltModalCallBackPhoneNumberSelector = "#cx_form_callback_phone_number";
        const ccassButtonDiv = ".ccaas-container";

        let liveChatAgentConnected = false;
        let liveChatStartedByAgentOrClient = false;
        let liveChatOpened = false;
        let liveChatEndedByAgent = false;

        function CcaasChatTracker() {
            this.scope = document.querySelector(ccaasBubbleSelector);
        }

        WaitForElement(".genesys-app", function () {
            //Web Messenger Events
            if (window.Genesys !== undefined) {
                new CcaasTracking("live_chat_loaded").trigger();

                window.Genesys("subscribe", "Conversations.opened", function ({ data }) {
                    new CcaasTracking("live_chat_open").trigger();
                });

                window.Genesys("subscribe", "Conversations.started", function ({ data }) {
                    new CcaasTracking("live_chat_started_by_client").trigger();
                });
            }
        }, defaultTimeoutValue);

        //function to wait for ccaas to appear and CXBus to be initialized
        WaitForElement(ccaasBubbleSelector, function () {
            //Universal event for detecting tooltip & firing event
            WaitForElement(".cs-help-tooltip.tooltip-open", function () {
                new CcaasTracking("live_chat_callout_displayed").trigger();
            }, 5000);

            var startTime = Date.now();
            var interval = setInterval(function () {
                if (window.CXBus !== undefined && window.utag !== undefined) {
                    clearInterval(interval);
                    CCaasEventTracking();
                } else {
                    if (Date.now() - startTime > observerTimeoutValue) {
                        clearInterval(interval);
                    }
                }
            }, 250);
        }, observerTimeoutValue);

        function CCaasEventTracking() {
            new CcaasTracking("live_chat_loaded").trigger();

            CXBus.subscribe("WebChatService.messageReceived", function (e) {

                var initiatedBy = ""; // who triggered the event so client or agent
                var eventType = ""; // event type e.g participant left chat or message

                if (e.data) {
                    if (e.data.messages) {
                        if (e.data.messages[0]) {
                            if (e.data.messages[0].from) {
                                if (e.data.messages[0].from.type) {
                                    initiatedBy = e.data.messages[0].from.type;
                                }
                            }
                            if (e.data.messages[0].type) {
                                eventType = e.data.messages[0].type;
                            }
                        }
                    }
                }

                if (initiatedBy != "" && eventType != "") {
                    if (initiatedBy.toLowerCase() == "client" && eventType.toLowerCase() == "message" && liveChatStartedByAgentOrClient == false) {
                        liveChatStartedByAgentOrClient = true;
                        new CcaasTracking("live_chat_started_by_client").trigger();
                    }
                    else if (initiatedBy.toLowerCase() == "agent" && eventType.toLowerCase() == "message" && liveChatStartedByAgentOrClient == false) {
                        liveChatStartedByAgentOrClient = true;
                        new CcaasTracking("live_chat_started_by_agent").trigger();
                    }
                }
            });
            CXBus.subscribe('WebChatService.agentConnected', function (message, agents, numAgentsConnected) {
                if (liveChatAgentConnected == false) {
                    liveChatAgentConnected = true;
                    new CcaasTracking("live_chat_agent_connected").trigger();
                }
            });
            CXBus.subscribe('WebChat.started', function (e) {
                if (liveChatOpened == false) {
                    liveChatOpened = true;
                    liveChatEndedByAgent = false; // after chat started track if its disconnected
                    new CcaasTracking("live_chat_open").trigger();
                }
            });
            CXBus.subscribe('WebChatService.agentDisconnected', function (message, agents, numAgentsConnected) {
                if (liveChatEndedByAgent == false) {
                    liveChatAgentConnected = false;
                    liveChatStartedByAgentOrClient = false;
                    liveChatOpened = false;
                    if (message.data) {
                        if (message.data.message) {
                            if (message.data.message.role && message.data.message.state) {
                                if (message.data.message.role.toLowerCase() == "agent" && message.data.message.state.toLowerCase() == "disconnected") {
                                    //reset back to false as they may open the chat again
                                    liveChatEndedByAgent = true;
                                    new CcaasTracking("live_chat_ended_by_agent").trigger();
                                }
                            }
                        }
                    }
                }
            });
        }

        CcaasChatTracker.prototype.start = function () {
            const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            WaitForPredictiveEgagement();
            // This will look for CCaaS bubble to exist on the page and once it is found then it will disconnect the observer
            var observer = new MutationObserver(function (mutations, observer) {
                // fired when a mutation occurs
                const ccaasBubble = document.querySelector(ccaasBubbleSelector);
                const ccaasAltBubble = document.querySelector(ccaasAltBubbleSelector);

                if (ccaasBubble) {
                    this.scope = ccaasBubble;
                    $(ccaasBubble).on("click", OnCcaasBubbleClick);

                    // This will disconnect once the element has been found
                    observer.disconnect();
                } else if (ccaasAltBubble) {
                    this.scope = ccaasAltBubble;
                    WaitForElement(ccaasAltBubbleSelector, defaultTimeoutValue);
                    observer.disconnect();
                }
            });

            // define what element should be observed by the observer
            // and what types of mutations trigger the callback
            observer.observe(document,
                {
                    childList: true,
                    characterData: true,
                    subtree: true
                });

            // If after some time has passed (~1 min) automatically disconnect the observer so it will stop looking for the element
            setTimeout(function () {
                observer.disconnect();
            },
                observerTimeoutValue);
        };

        function OnCcaasBubbleClick() {
            //Initiate chat event
            const data = buttonClickEvent.GenerateEventMetadata(event.currentTarget);
            tealium.event(data);

            WaitForElement(ccaasClose, function () {

                //if not FR
                if ($('[aria-label="Start Chat"]').is(":visible")) {
                    //Start Chat button
                    const startChatButton = $(startChatButtonSelector);
                    if (startChatButton == null) return;
                    startChatButton.unbind("click").on("click", OnStartChatButtonClick);

                    //First name completed
                    //Adaptation for different input ids
                    var nameInput = document.querySelector(ccaasFirstName);
                    if (nameInput == null) {
                        nameInput = document.querySelector(ccaasNameInput);
                        if (nameInput == null) return;
                    }

                    const firstName = nameInput;
                    this.scope = firstName;

                    $(firstName).off("focusout").on("focusout", function () {
                        if (firstName.className === "cx-input cx-form-control" && firstName.value.length > 0) {
                            new CcaaSEvent("", "form field complete", "component", "name_field", "field_completion", "", "ccaas-btn", "body").trigger();
                        }
                    });
                    //Account field completed
                    const accountNumber = document.querySelector(ccaasAccount);
                    if (accountNumber == null) return;
                    this.scope = accountNumber;
                    $(accountNumber).off("focusout").on("focusout", function () {
                        if (accountNumber.value.length > 0) {
                            new CcaaSEvent("", "form field complete", "component", "account_number", "field_completion", "", "ccaas-btn", "body").trigger();
                        }
                    });
                    //Subject field completed
                    const subject = document.querySelector(ccaasSubject);
                    if (subject == null) return;
                    this.scope = subject;
                    $(subject).off("focusout").on("focusout", function () {
                        if (subject.value.length > 0) {
                            new CcaaSEvent("", "form field complete", "component", "subject", "field_completion", "", "ccaas-btn", "").trigger();
                        }
                    });
                    //Email field completed
                    const email = document.querySelector(ccaasEmail);
                    if (email == null) return;
                    this.scope = email;
                    $(email).off("focusout").on("focusout", function () {
                        if (email.value.length > 0) {
                            new CcaaSEvent("", "form field complete", "component", "email", "field_completion", "", "ccaas-btn", "").trigger();
                        }
                    });
                    //Cancel button
                    const cancel = document.querySelector(ccaasCancel);
                    if (cancel == null) return;
                    this.scope = cancel;
                    $(cancel).on("click", function () {
                        new CcaaSEvent("", "chat_cancel", "component", "initiate", "button_click", "", "ccaas-cancel-btn", "").trigger();
                        //return the focus to the ccaas button after closing the chat
                        const ccaasBtnDiv = document.querySelector(ccassButtonDiv);
                        if (ccaasBtnDiv == null) return;
                        ccaasBtnDiv.focus();
                    });
                    //Minimize/Maximize button
                    const minimize = document.querySelector(ccaasMinimize);
                    if (minimize) {
                        this.scope = minimize;
                        $(minimize).on("click", function () {
                            if ($(minimize).attr("class") === "cx-icon cx-button-minimize") {
                                new CcaaSEvent("", "chat_window_minimize", "component", "initiate", "button_click", "", "ccaas-window-minimize", "").trigger();
                            } else {
                                new CcaaSEvent("", "chat_window_maximize", "component", "initiate", "button_click", "", "ccaas-window-maximize", "").trigger();
                            }
                        });
                    }
                }

                //Close button
                const close = document.querySelector(ccaasClose);
                if (close == null) return;
                this.scope = close;

                $(close).off("click").on("click", function () {
                    new CcaaSEvent("", "chat_window_close_X", "component", "initiate", "X_button_click", "", "ccaas-window-X-button", "").trigger();

                    WaitForElement(".cx-end-confirm", function () {
                        new CcaasTracking("live_chat_attempt_to_close").trigger();
                        OnCcaasEndChatClick();
                        //Confirm End button
                        const confirmEndBtn = $(".cx-end-confirm");

                        $(confirmEndBtn).off("click").on("click", function () {
                            new CcaasTracking("live_chat_ended_by_client").trigger();
                            WaitForElement(".cx-toast.cx-close ", function () {
                                new CcaasTracking("live_chat_transcript_offered").trigger();
                                var yesBtn = $(".cx-toast.cx-close .cx-buttons-binary .cx-btn-primary");
                                var noBtn = $(".cx-toast.cx-close .cx-buttons-binary .cx-btn-default");

                                $(yesBtn).off("click").on("click", function () {
                                    new CcaasTracking("live_chat_transcript_accepted").trigger();
                                });
                                $(noBtn).off("click").on("click", function () {
                                    new CcaasTracking("live_chat_transcript_rejected").trigger();
                                });
                            }, 3000);
                        });
                    }, 3000);

                    //Multi-channel - Transcript
                    WaitForElement("#cx-chat-save-conversation", function () {
                        new CcaasTracking("live_chat_transcript_offered").trigger();

                        $("#cx-chat-save-conversation").on("click", function () {
                            new CcaasTracking("live_chat_transcript_accepted").trigger();
                        });
                    }, 3000);
                });
            }, observerTimeoutValue);
        }
        function OnStartChatButtonClick() {
            setTimeout(function () {
                if ($(messageInputSelector) && $(messageInputSelector).is(":visible"))
                    new CcaaSEvent("", "start_chat_click", "component", "initiate", "button_click", "", "ccaas-chat-btn", "").trigger();
            }, defaultTimeoutValue);
        }
        function OnCcaasEndChatClick() {
            new CcaasAltEvent("chat_dismissed", "component", "visible", "chat_dismissed", "chat-modal", GetProductName(), "End_chat_button", "lower body", "0").trigger();
        }
        function OnCccasSendButtonClick() {
            new CcaasAltEvent("chat_sent", "component", "visible", "chat_sent", "chat-modal", GetProductName(), "chat_send_button", "lower body", "0").trigger();
        }

        //CCAAS ALT Events (FR)
        //Chat events
        eventManager.subscribe("OnCcaasAltModalSendChatClick", function () {
            WaitForElement(ccaasAltModalFormSendChatSelector, function () {
                if ($(ccaasAltModalFormSendChatSelector).is(":visible")) {
                    const nameOfModal = GetNameOfModal(ccaasAltModalFormSendChatSelector);
                    //Minimize modal callback
                    if ($(ccaasAltMinimizeIconSelector).is(":visible")) {
                        $(ccaasAltMinimizeIconSelector).off("click").on("click",
                            function () {
                                OnCcaasAltModalMinimizeClick("chat_en_direct", nameOfModal);
                            });
                    }
                    //Close modal send message
                    if ($(ccaasAltCloseIconSelector).is(":visible")) {
                        $(ccaasAltCloseIconSelector).off("click").on("click",
                            function () {
                                OnCcaasAltModalCloseClick("chat_en_direct", nameOfModal);
                            });
                    }
                }
            }, observerTimeoutValue);
        });
        //Message events
        eventManager.subscribe("OnCcaasAltModalSendMessageClick",
            function () {
                WaitForElement(ccaasAltModalFormSendMessageSelector,
                    function () {
                        if ($(ccaasAltModalFormSendMessageSelector).is(":visible")) {
                            const nameOfModal = GetNameOfModal(ccaasAltModalFormSendMessageSelector);
                            //Minimize modal callback
                            if ($(ccaasAltMinimizeIconSelector).is(":visible")) {
                                $(ccaasAltMinimizeIconSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalMinimizeClick("envoyer_un_message", nameOfModal);
                                    });
                            }
                            //Close modal send message
                            if ($(ccaasAltCloseIconSelector).is(":visible")) {
                                $(ccaasAltCloseIconSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalCloseClick("envoyer_un_message", nameOfModal);
                                    });
                            }
                            //Email field completed
                            OnCcaasAltModalFieldCompleteFocusout("envoyer_un_message", ccaasAltModalFormEmailSelector, nameOfModal);
                            //Firstname field completed
                            OnCcaasAltModalFieldCompleteFocusout("envoyer_un_message", ccaasAltModalFormFirstnameSelector,
                                nameOfModal);
                            //Question field completed
                            OnCcaasAltModalFieldCompleteFocusout("envoyer_un_message", ccaasAltModalFormQuestionSelector,
                                nameOfModal);
                            //form send button
                            if ($(ccaasAltModalFormSendButtonSelector).is(":visible")) {
                                WaitForElement(ccaasAltModalFormSendSuccessTextSelector,
                                    function () {
                                        new CcaasTracking("live_chat_contact_form_submitted").trigger();
                                        OnCcaasAltModalSendFormSubmitClick(nameOfModal);
                                    }, 10 * observerTimeoutValue);
                            }
                        }
                    },
                    observerTimeoutValue);
            });
        //callback events
        eventManager.subscribe("OnCcaasAltModalCallbackClick",
            function () {
                WaitForElement(ccaasAltModalCallBackSelector,
                    function () {
                        if ($(ccaasAltModalCallBackSelector).is(":visible")) {
                            var nameOfModal = GetNameOfModal(ccaasAltModalCallBackSelector);
                            //Minimize modal callback
                            if ($(ccaasAltMinimizeIconSelector).is(":visible")) {
                                $(ccaasAltMinimizeIconSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalMinimizeClick("recevoir_un_appel", nameOfModal);
                                    });
                            }
                            //Close modal callback
                            if ($(ccaasAltCloseIconSelector).is(":visible")) {
                                $(ccaasAltCloseIconSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalCloseClick("recevoir_un_appel", nameOfModal);
                                    });
                            }
                            //Phone Number field completed
                            OnCcaasAltModalFieldCompleteFocusout("recevoir_un_appel", ccaasAltModalCallBackPhoneNumberSelector,
                                nameOfModal);
                            //Schedule desired time selection
                            if ($(ccaasAltModalCallBackDesiredTimeSelector).is(":visible")) {
                                $(ccaasAltModalCallBackDesiredTimeSelector).on("click", function () {
                                    new CcaasAltEvent("button_click", "component", "recevoir_un_appel", "time_selection", nameOfModal, $(this).text(), $(ccaasAltModalCallBackDesiredTimeSelector).attr("id"), "body", "0").trigger();
                                });
                            }
                            //form cancel button
                            if ($(ccaasAltModalCallBackCancelButtonSelector).is(":visible")) {
                                $(ccaasAltModalCallBackCancelButtonSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalCallBackCancelClick(nameOfModal);
                                    });
                            }
                            //form confirm button
                            if ($(ccaasAltModalCallBackConfirmButtonSelector).is(":visible")) {
                                $(ccaasAltModalCallBackConfirmButtonSelector).off("click").on("click",
                                    function () {
                                        OnCcaasAltModalCallBackConfirmClick(nameOfModal);
                                    });
                            }
                        }
                    },
                    observerTimeoutValue);
            });

        //Generic Helper Functions
        function OnCcaasAltModalMinimizeClick(panel, nameOfModal) {
            //Close callback trigger
            new CcaasAltEvent("minimize_click", "component", panel, "panel_minimized", nameOfModal, "", "minimize_button", "body", "0").trigger();
        }
        function OnCcaasAltModalCloseClick(panel, nameOfModal) {
            //Close callback trigger
            new CcaasAltEvent("close_click", "component", panel, "panel_closed", nameOfModal, "", "close_button", "body", "0").trigger();
        }
        function OnCcaasAltModalFieldCompleteFocusout(panel, fieldSelector, nameOfModal) {
            if (IsNullOrWhiteSpace(fieldSelector)) return;
            const field = $(fieldSelector);
            if (field.length) {
                if (field.is(":visible")) {
                    field.off("focusout").on("focusout",
                        function () {
                            if (field.val().length > 0) {
                                new CcaasAltEvent(field.attr("name") + "_field_enter", "component", panel, "field_complete", nameOfModal, "", field.attr("id"), "body", "0").trigger();
                            }
                        });
                }
            }
        }

        //Message specific helper functions
        function OnCcaasAltModalSendFormSubmitClick(nameOfModal) {
            //Form submit trigger

            new CcaasAltEvent("submit_click", "component", "envoyer_un_message", "submit_click", nameOfModal, "", "submit_button", "body", "0").trigger();
            //modal Send Message Success
            if ($(ccaasAltCloseIconSelector).is(":visible")) {
                $(ccaasAltCloseIconSelector).off("click").on("click", function () {
                    //Close modal trigger
                    new CcaasAltEvent("close_click", "component", "envoyer_un_message", "confirmation_panel_closed", GetNameOfModal(ccaasAltModalFormSendSuccess), "", "close_button", "body", "0").trigger();
                });
            }
        }
        //Callback specific helper functions
        function OnCcaasAltModalCallBackCancelClick(nameOfModal) {
            //Cancel callback trigger
            new CcaasTracking("live_chat_callback_form_rejected").trigger();
            new CcaasAltEvent("cancel_click", "component", "recevoir_un_appel", "phone_cancel", nameOfModal, "", "cancel_button", "body", "0").trigger();
        }
        function OnCcaasAltModalCallBackConfirmClick(nameOfModal) {
            //Confirm callback trigger
            new CcaasTracking("live_chat_callback_form_submitted").trigger();
            new CcaasAltEvent("confirmer_click", "component", "recevoir_un_appel", "submit_click", nameOfModal, "", "confirmer_button", "body", "0").trigger();
        }

        //proactive engagement events
        var predictiveEngagementIteration = 0;
        function WaitForPredictiveEgagement() {
            if (typeof window.ac !== "undefined") {
                console.log("Found predictive engagement");
                //variable exists, do what you want
                ac('on', 'webchat:offered', function (event) {
                    new CcaasTracking("live_chat_toaster_displayed").trigger();
                    new CcaasAltEvent("chat_served", "component", "visible", "chat_modal_visible", "chat-modal", GetProductName(), "ccaas-modal", "lower body", "0", GetEventActionDisplayName(event)).trigger();
                });

                ac('on', 'webchat:rejected', function (event) {
                    new CcaasTracking("live_chat_toaster_rejected").trigger();
                    new CcaasAltEvent("button_click", "component", "initiate", "No_thanks_click", "chat-modal", GetProductName(), "No_thanks_buttons", "lower body", "0", GetEventActionDisplayName(event)).trigger();
                });

                ac('on', 'webchat:accepted', function (event) {
                    new CcaasAltEvent("button_click", "component", "initiate", "Chat_with_us_click", "chat-modal", GetProductName(), "Chat_with_us_button", "lower body", "0", GetEventActionDisplayName(event)).trigger();
                });

                ac('on', 'webchat:started', function (event) {
                    new CcaasAltEvent("chat_served", "component", "visible", "Live_chat_console_start", "chat-modal", GetProductName(), "Live_chat_console", "lower body", "0", GetEventActionDisplayName(event)).trigger();

                    //Attach to send btn in new iFrame
                    WaitForElement(".cx-send", function () {
                        //Send message button
                        const sendMsgBtn = $(".cx-send");
                        if (sendMsgBtn == null) return;
                        sendMsgBtn.unbind("click").on("click", OnCccasSendButtonClick);
                    }, observerTimeoutValue);

                    //Attach to close button in new iFrame
                    const close = document.querySelector(ccaasClose);
                    if (close == null) return;
                    this.scope = close;
                    $(close).on("click", function () {
                        new CcaaSEvent("", "chat_window_close_X", "component", "initiate", "X_button_click", GetProductName(), "ccaas-window-X-button", "").trigger();

                        //Attach to confirm button in new iFrame
                        WaitForElement(".cx-end-confirm ", function () {
                            const confirmEndBtn = $(".cx-end-confirm");
                            if (confirmEndBtn == null) return;
                            confirmEndBtn.unbind("click").on("click", OnCcaasEndChatClick);
                        }, observerTimeoutValue);
                    });
                });
            }
            else {
                predictiveEngagementIteration++;
                if (predictiveEngagementIteration <= 20) {
                    setTimeout(WaitForPredictiveEgagement, (predictiveEngagementIteration * 50));
                }
            }
        }

        //UTIL
        function GetEventActionDisplayName(event) {
            if (event) {
                return event.actionMapDisplayName;
            }
        }
        function WaitForElement(selector, callback, maxTime) {
            var startTime = Date.now();
            var interval = setInterval(function () {
                if ($(selector).is(":visible")) {
                    clearInterval(interval);
                    callback();
                } else {
                    if (Date.now() - startTime > maxTime) {
                        clearInterval(interval);
                    }
                }
            },
                100
            );
        }
        function IsNullOrWhiteSpace(text) {
            return text == null || text.match(/^ *$/) != null;
        }
        function SpaceReplace(text) {
            if (!IsNullOrWhiteSpace(text)) {
                const refinedText = text.trim().replace(/ /g, "_");
                return ReplaceAccents(refinedText);
            }
            return text;
        }
        function ReplaceAccents(text) {
            if (!IsNullOrWhiteSpace(text)) {
                const accent = [
                    /[\xc0-\xc6]/g, /[\xe0-\xe6]/g, // A, a
                    /[\xc7]/g, /[\xe7]/g, // C, c
                    /[\xc8-\xcb]/g, /[\xe8-\xeb]/g, // E, e
                    /[\xcc-\xcf]/g, /[\xec-\xef]/g, // I, i
                    /[\xd1]/g, /[\xf1]/g, // N, n
                    /[\xd2-\xd8]/g, /[\xf2-\xf8]/g, // O, o
                    /[\xd9-\xdc]/g, /[\xf9-\xfc]/g // U, u
                ];
                const noaccent = ["A", "a", "C", "c", "E", "e", "I", "i", "N", "n", "O", "o", "U", "u"];
                for (let i = 0; i < accent.length; i++) {
                    text = text.replace(accent[i], noaccent[i]);
                }
            }
            return text;
        }
        function GetNameOfModal(modalSelector) {
            if (IsNullOrWhiteSpace(modalSelector))
                return "";
            const modal = $(modalSelector);
            return (modal == null) ? "" : SpaceReplace(modal.attr("aria-label"));
        }
        function GetProductName() {
            if (window.utag.data.product_name) {
                return window.utag.data.product_name.join(", ");
            } else {
                return "";
            }
        }

        return CcaasChatTracker;
    });

